var GeneralScopeActions, GeneralScopeStore, PouchSource, alt, immutable, mediator;

alt = require('alt');

mediator = require('mediator');

GeneralScopeActions = require('actions/general_scope_actions');

PouchSource = require('stores/sources/pouch_source');

immutable = require('stores/utils/immutable');

GeneralScopeStore = (function() {
  function GeneralScopeStore() {
    this.state = Immutable.fromJS({
      _meta: {
        activeContentEditableId: '',
        showingExportDialog: false,
        fetching: false
      },
      scope: {}
    });
    this.exportPublicMethods({
      getActiveContentEditable: this.getActiveContentEditable,
      isFetching: this.isFetching,
      isShowingExportDialog: this.isShowingExportDialog,
      getScopeData: this.getScopeData
    });
    this.bindActions(GeneralScopeActions);
    this.registerAsync(PouchSource(GeneralScopeActions));
  }

  GeneralScopeStore.prototype.onFetch = function(data) {
    this.setState(this.state.setIn(['_meta', 'fetching'], true));
    return this.getInstance().fetch(data.projectId, data.projectId);
  };

  GeneralScopeStore.prototype.onPouchFetchSuccess = function(projectDoc) {
    var _ref;
    return this.setState(this.state.set('scope', Immutable.fromJS((_ref = projectDoc.scope) != null ? _ref : {})).setIn(['_meta', 'fetching'], false));
  };

  GeneralScopeStore.prototype.onPouchFetchFailure = function(e) {
    this.setState(this.state.setIn(['_meta', 'fetching'], false));
    return console.error(e);
  };

  GeneralScopeStore.prototype.onPouchSaveSuccess = function(projectDoc) {
    return this.setState(this.state.set('scope', Immutable.fromJS(projectDoc.scope)));
  };

  GeneralScopeStore.prototype.onToggleExportDialog = function() {
    var flagPath;
    flagPath = ['_meta', 'showingExportDialog'];
    return this.setState(this.state.setIn(flagPath, !this.state.getIn(flagPath)));
  };

  GeneralScopeStore.prototype.onEnableContentEditable = function(contentEditableId) {
    return this.setState(this.state.setIn(['_meta', 'activeContentEditableId'], contentEditableId));
  };

  GeneralScopeStore.prototype.onDisableContentEditable = function() {
    return this.setState(this.state.setIn(['_meta', 'activeContentEditableId'], ''));
  };

  GeneralScopeStore.prototype.onUpdateContentEditableContent = function(data) {
    var content, doc, fieldName;
    fieldName = data.fieldName, content = data.content;
    this.setState(this.state.setIn(['scope', fieldName], content));
    doc = mediator.project.toJSON();
    doc.scope = this.state.get('scope').toJS();
    return this.getInstance().save(mediator.project.id, doc);
  };

  GeneralScopeStore.prototype.isFetching = function() {
    return this.state.getIn(['_meta', 'fetching']);
  };

  GeneralScopeStore.prototype.isShowingExportDialog = function() {
    return this.state.getIn(['_meta', 'showingExportDialog']);
  };

  GeneralScopeStore.prototype.getActiveContentEditable = function() {
    return this.state.getIn(['_meta', 'activeContentEditableId']);
  };

  GeneralScopeStore.prototype.getScopeData = function() {
    return this.state.get('scope');
  };

  return GeneralScopeStore;

})();

module.exports = alt.createStore(immutable(GeneralScopeStore), 'GeneralScopeStore');
